import { ImageEnum } from '../utils/image.enum';

export interface SidebarItem {
  label: string;
  route: string;
  icon: ImageEnum;
  activeIcon: ImageEnum;
  exact?: boolean;
}

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    label: 'Dashboard',
    route: '/dashboard',
    icon: ImageEnum.DASHBOARD_BLACK,
    activeIcon: ImageEnum.DASHBOARD_WHITE,
    exact: true,
  },
  {
    label: 'Test Series',
    route: '/test-series',
    icon: ImageEnum.FILE_STACK_BLACK,
    activeIcon: ImageEnum.FILE_STACK_WHITE,
    exact: true,
  },
  {
    label: 'Bookmarks',
    route: '/test-series/bookmarks',
    icon: ImageEnum.BOOKMARK_BLACK,
    activeIcon: ImageEnum.BOOKMARK_WHITE,
    exact: true,
  },
  {
    label: 'Performance',
    route: '/test-series/performance',
    icon: ImageEnum.PERFORMANCE_INACTIVE,
    activeIcon: ImageEnum.PERFORMANCE_ACTIVE,
    exact: false,
  },
];
